/* ==========================================================================
   IRON FIT — Meta pixel

   The same pixel the old store ran (1571660194566977), so the audiences and
   the conversion history already sitting in Ads Manager keep working.

   What it reports:
     PageView         · every page, automatically
     ViewContent      · a machine or a package page is opened
     AddToCart        · anything is added to the cart, with its real value
     InitiateCheckout · the order form is opened
     Purchase         · the order is placed (cash on delivery, so "placed"
                        IS the conversion — nothing is charged online)

   Every call goes through IFZPixel.track, which is a no-op if the pixel
   script is blocked, so an ad-blocker can never break the checkout.
   ========================================================================== */
window.IFZPixel = (function () {
  'use strict';

  var ID = '1571660194566977';
  var CURRENCY = 'USD';

  /* ------------------------------------------------------------------
     WHO OWNS THE PIXEL DEPENDS ON WHERE THIS IS RUNNING.

     Static site: nothing else has loaded fbq, so this file owns the whole
     thing — loader, init, and PageView.

     Shopify theme: layout/ironfit.liquid has ALREADY loaded fbq and called
     init, and its comment is explicit about why it does not send PageView:
     Shopify's Facebook & Instagram channel sends PageView and Purchase, so
     a second call double-counts. Re-initialising and re-sending PageView
     here would corrupt the conversion data the ad account is optimised on.

     So: if fbq already exists, we adopt it and send nothing extra. The
     store's own events (ViewContent, AddToCart, Purchase) still fire,
     because those are ours to send and nothing else is sending them from
     this front end.
     ------------------------------------------------------------------ */
  var adopted = !!window.fbq;

  if (!adopted) {
    /* Meta's own loader, kept verbatim apart from the id. */
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    try {
      window.fbq('init', ID);
      window.fbq('track', 'PageView');
    } catch (e) {}
  }

  function track(event, data) {
    try { window.fbq('track', event, data || {}); } catch (e) {}
  }

  /* Cart items → the contents array Meta expects, so the value in Ads
     Manager matches the money actually being asked for. */
  function contents(items) {
    return (items || []).map(function (it) {
      return {
        id: it.name,
        quantity: 1,
        item_price: window.IFZCart ? window.IFZCart.itemTotal(it) : it.price
      };
    });
  }

  function value(items) {
    return (items || []).reduce(function (t, it) {
      return t + (window.IFZCart ? window.IFZCart.itemTotal(it) : it.price);
    }, 0);
  }

  return {
    id: ID,
    currency: CURRENCY,
    track: track,

    viewContent: function (name, price) {
      track('ViewContent', { content_name: name, value: price, currency: CURRENCY });
    },

    addToCart: function (item) {
      track('AddToCart', {
        content_name: item.name,
        contents: contents([item]),
        content_type: 'product',
        value: value([item]),
        currency: CURRENCY
      });
    },

    initiateCheckout: function (items) {
      track('InitiateCheckout', {
        contents: contents(items),
        content_type: 'product',
        num_items: items.length,
        value: value(items),
        currency: CURRENCY
      });
    },

    purchase: function (items, orderId) {
      track('Purchase', {
        contents: contents(items),
        content_type: 'product',
        num_items: items.length,
        value: value(items),
        currency: CURRENCY,
        order_id: orderId
      });
    }
  };
})();
